export const configGenericColumnDatable = {
  ignoreRowClick: true,
  allowOverflow: true,
  button: true,
}
